import React,{useState} from "react";
import { Link } from "react-router-dom";

import bg1 from "../assets/images/bg/join_us.webp"
import cta from "../assets/images/cta.jpg"
import joinourteam from "../assets/images/joinourteam1.webp"

import NavbarTwo from "../components/navbar/navbarTwo"
import ClientTwo from "../components/client/clientTwo";
import Partners from "../components/partners";
import Team from "../components/team";
import FooterThree from "../components/footer/footerThree";
import ScrollTop from "../components/scrollTop";

import ModalVideo from 'react-modal-video';
import '../../node_modules/react-modal-video/css/modal-video.css';

import {AiOutlineCheckCircle, FiAirplay, LiaReact, FiUsers,FiArrowRight} from '../assets/icons/vander'
import CountUp from 'react-countup';

export default function AboutUs(){
    const [isOpen, setOpen] = useState(false);
    const aboutData = [
        {
            icon:FiAirplay,
            title:'Developing strategy',
            desc:'It is said that song composers of the past used dummy texts as lyrics when writing to sing with the melody.'
        },
        {
            icon:LiaReact,
            title:'Blazing performance',
            desc:'It is said that song composers of the past used dummy texts as lyrics when writing to sing with the melody.'
        },
        {
            icon:FiUsers,
            title:'Customer satisfaction',
            desc:'It is said that song composers of the past used dummy texts as lyrics when writing to sing with the melody.'
        },
    ]
    const counterData = [
        {
            start:'0',
            end:'5458',
            title:'Investment Projects'
        },
        {
            start:'0',
            end:'15',
            title:'Years of Experience'
        },
        {
            start:'0',
            end:'54',
            title:'Offices in the World'
        },
        {
            start:'0',
            end:'214',
            title:'Successful Cases'
        },
    ]
    return(
        <>
        <NavbarTwo navClass="defaultscroll sticky" manuClass="navigation-menu nav-right nav-light"/>

        <section className="bg-half-170 d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
            <div className="bg-overlay bg-gradient-overlay"></div>
            <div className="container">
                <div className="row mt-5 justify-content-center">
                    <div className="col-12">
                        <div className="title-heading text-center">
                            <small className="text-white-50 mb-1 fw-medium text-uppercase mx-auto">Want to be a part of something amazing?</small>
                            <h5 className="heading fw-semibold mb-0 page-heading text-white title-dark">Join Our Team!</h5>
                        </div>
                    </div>
                </div>

                <div className="position-middle-bottom">
                    <nav aria-label="breadcrumb" className="d-block">
                        <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Join Us</li>
                        </ul>
                    </nav>
                </div>
            </div>
        </section>
        <section className="section">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-5 col-md-6">
                        <img src={joinourteam} className="img-fluid rounded shadow" alt=""/>
                    </div>

                    <div className="col-lg-7 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
                        <div className="section-title ms-lg-5">
                            <h4 className="title mb-3">We’re building something different ... <br></br>and we’re looking for people who believe in what we’re doing.</h4>
                            <p className="text-muted2">Whether you're a licensed insurance professional or exploring a new career path, if you're purpose-driven, equity-minded, and passionate about helping others, we want to hear from you. At Inclusive Family Insurance, we're building a team that reflects the communities we serve—diverse, compassionate, and committed to doing what's right. If you're ready to make a difference, fill out the form below and let’s start the conversation. We’re excited to meet you.</p>
                            <ul className="list-unstyled text-muted2">
                                <li className="mb-0"><span className="text-dark h5 me-2"><AiOutlineCheckCircle className="align-middle"/></span>Learn more about Symmetry Financial Group. </li>
                                <li className="mb-0"><span className="text-dark h5 me-2"><AiOutlineCheckCircle className="align-middle"/></span>Questions? Click the <b>Contact Us Now</b> button below, we're happy to help.</li>
                            </ul>                        
                        </div>
                    </div>
                </div>
            </div>

            
        </section>
        <FooterThree/>
        <ScrollTop/>
        </>
    )
}